import { Component } from "@/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "grid"

export const presets = {}

export interface Props extends Component {}

export function Grid({ children, className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`grid grid-cols-12`, className)} data-test={testId}>
      {children}
    </div>
  )
}
